import React from 'react';
import './App.css';

function App() {
  return (
    <div className="App">
      <div className="coming-soon-container">
        <h1>Coming Soon</h1>
        <p>Kame Software</p>
      </div>
    </div>
  );
}

export default App;
